module.exports = __webpack_public_path__ + "media/assets/images/flags/cu-d7527727792f60b794a25786a59d80cc.svg";